// @todo: Migrate to 'Switch' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Switch} from '@wandb/weave/components';
import React, {useState} from 'react';
import {useParams} from 'react-router-dom';

import {
  mediaVideoSyncDisabled,
  mediaVideoSyncEnabled,
} from '../../../../../services/analytics/productEvents';
import {useVideoPlaybackSyncSettings} from '../../hooks/useVideoPlaybackSyncSettings';
import {SettingTitle} from '../common/SettingTitle';
import {useMediaSettingsDrawerContext} from '../MediaSettingsDrawerContextProvider';

export const VideoPlaybackSync = () => {
  const {config, updateConfig, unsetConfigField, settingsLevel} =
    useMediaSettingsDrawerContext();
  const {isEnabled, isInherited} = useVideoPlaybackSyncSettings(
    config,
    settingsLevel
  );
  const {entityName, projectName} = useParams<{
    entityName: string;
    projectName: string;
  }>();

  const [shouldSyncVideoPlayback, setShouldSyncVideoPlayback] =
    useState(isEnabled);

  return (
    <div className="flex justify-between gap-24">
      <SettingTitle
        title="Sync video playback"
        description="Adjusting one player updates all others."
        configField="videoPlaybackSync"
      />
      <Switch.Root
        aria-label="Toggle video playback sync"
        data-test="sync-video-playback-switch"
        checked={shouldSyncVideoPlayback}
        className={isInherited ? 'opacity-50' : ''}
        disabled={isInherited}
        onCheckedChange={newValue => {
          setShouldSyncVideoPlayback(newValue);
          // Allow the switch to animate before updating the config so that it's more of a smooth
          // transition before the component re-mounts
          setTimeout(() => {
            if (newValue) {
              updateConfig({
                videoPlaybackSync: newValue,
              });
              mediaVideoSyncEnabled({
                entityName: entityName,
                projectName: projectName,
                level: settingsLevel,
              });
            } else {
              unsetConfigField('videoPlaybackSync');
              mediaVideoSyncDisabled({
                entityName: entityName,
                projectName: projectName,
                level: settingsLevel,
              });
            }
          }, 100);
        }}>
        <Switch.Thumb checked={shouldSyncVideoPlayback ?? false} />
      </Switch.Root>
    </div>
  );
};
